import { FLAGS } from '@iheartjane/feature-flags';
import { useEffect } from 'react';

import { trackAbTest } from '@jane/bloom/services/tracking/track';

import { useRootLoaderData } from './useRootLoaderData';
import { useShowInlineWizardCta } from './useShowInlineWizardCta';

/**
 * AB test that removes the wizard banner from the featured and shop-all pages
 * in favor of the wizard button in the filter bars, matching the other menu
 * pages.
 *
 * Returns whether the banner should be replaced by the button. Exposure is
 * only tracked when `eligible` is true — pass the page-level condition for
 * showing the banner (e.g. `!category` on the category route) so pages that
 * never show the banner don't dilute the experiment.
 */
export function useRemoveWizardBannerAbTest(eligible = true): boolean {
  const { featureFlags } = useRootLoaderData();
  const showInlineWizardCta = useShowInlineWizardCta();
  const removeWizardBanner = Boolean(featureFlags[FLAGS.c2RemoveWizardBanner]);
  const trackExposure = eligible && showInlineWizardCta;

  useEffect(() => {
    if (!trackExposure) return;
    trackAbTest({
      enabled: removeWizardBanner,
      experiment: 'Remove Wizard Banner',
    });
  }, [trackExposure, removeWizardBanner]);

  return showInlineWizardCta && removeWizardBanner;
}
